import * as React from "react";
import { connect } from "react-redux";
import { Loader } from "semantic-ui-react";

import { CertificateModel } from "@teamprevent/common/healthSurveillance/certificate/models";
import { HealthSurveillanceCertificate as BaseHealthSurveillanceCertificate }
    from "@teamprevent/common/healthSurveillance/certificate/HealthSurveillanceCertificate";

import { useCustomMedicalTypes } from "../../../customMedicalTypes/hooks/useCustomMedicalTypes";

import { healthSurveillanceCertificateApi } from "../healthSurveillanceCertificateApi";
import { ApplicationState } from "../../../applicationState";
import { routeIdSelector as customerIdSelector } from "../../../crud/customer/selectors";
import { routeIdSelector as ohCaseIdSelector } from "../../../crud/ohCase/selectors";
import { taskIdSelector } from "../../../task/selectors";

interface Props {
    customerId: string;
    ohCaseId: string;
    taskId: string;
}

const HealthSurveillanceCertificateUnconnected: React.FunctionComponent<Props> = (props) => {
    const { customerId, ohCaseId, taskId } = props;
    const [model, setModel] = React.useState<CertificateModel>();
    const { customMedicalTypes, isLoaded: areCustomMedicalTypesLoaded } = useCustomMedicalTypes();

    React.useEffect(() => {
        (async () => {
            const certificateData = await healthSurveillanceCertificateApi.getHealthSurveillanceCertificate(customerId, ohCaseId, taskId);
            setModel(certificateData);
        })();
    }, [customerId, ohCaseId, taskId]);

    if (!model || areCustomMedicalTypesLoaded === false)
    {
        return <Loader active />;
    }

    return (
        <BaseHealthSurveillanceCertificate model={model} customMedicalTypes={customMedicalTypes} />
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    customerId: customerIdSelector(state),
    ohCaseId: ohCaseIdSelector(state),
    taskId: taskIdSelector(state)
});

export const HealthSurveillanceCertificate = connect(mapStateToProps)(HealthSurveillanceCertificateUnconnected);
